import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {
  Button,
  Field,
  List,
  Picker,
  Popup,
  Loading,
  Overlay,
  Cascader,
  Uploader
} from 'vant'
import * as api from './api'
import './assets/styles/style.css'

Vue.use(Button)
Vue.use(Field)
Vue.use(List)
Vue.use(Picker)
Vue.use(Popup)
Vue.use(Loading)
Vue.use(Overlay)
Vue.use(Cascader)
Vue.use(Uploader)


import 'vant/lib/button/style';
import 'vant/lib/field/style';
import 'vant/lib/list/style';
import 'vant/lib/picker/style';
import 'vant/lib/popup/style';
import 'vant/lib/overlay/style';
import 'vant/lib/loading/style';
import 'vant/lib/cascader/style';
import 'vant/lib/uploader/style';

Vue.prototype.$api = api
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
